import { Dropdown, Menu, Space } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import ReactApexChart from "react-apexcharts";
import "./CallTypeDoughnutCard.scss";

interface CallType {
  call_type_name: string | null;
  service_id: number;
  count: string;
}

interface Props {
  callTypes: CallType[];
}

const CallTypeDoughnutCard = ({ callTypes }: Props) => {
  const aggregatedData = (callTypes || []).reduce<Record<string, number>>(
    (acc, item) => {
      const name = item?.call_type_name || "Unknown";
      const count = parseInt(item?.count || "0", 10);
      acc[name] = (acc[name] || 0) + count;
      return acc;
    },
    {}
  );

  const chartLabels = Object.keys(aggregatedData || {});
  const chartSeries = Object.values(aggregatedData || {});

  const chartOptions = {
    chart: {
      type: "donut",
    },
    labels: chartLabels,
    colors: [
      "#6665a3",
      "#e69950",
      "#955196",
      "#b74e4c",
      "#878888",
      "#52c41a",
      "#faad14",
    ],
    legend: {
      position: "right",
      offsetY: 0,
      height: "auto",
      fontSize: "12px",
      fontWeight: 400,
      labels: { colors: "#2d3b3c" },
      itemMargin: { horizontal: 8, vertical: 4 },
      markers: { width: 10, height: 10, radius: 6 },
      useHTML: true, // 👈 necessary for tooltips to work

      // ✨ Tooltip + truncation
      formatter: function (seriesName: string) {
        const truncated =
          seriesName.length > 10 ? seriesName.slice(0, 14) + "..." : seriesName;
        return `<span title="${seriesName}" style="cursor:default;">${truncated}</span>`;
      },
    },
    tooltip: {
      enabled: true,
    },
    dataLabels: { enabled: false },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
          labels: {
            show: true,
            name: { show: true },
            value: {
              show: true,
              fontSize: "22px",
              fontWeight: "bold",
              color: "#1E1F21",
              offsetY: 0,
            },
            total: {
              show: true,
              label: "Total tickets",
              formatter: (w: any) =>
                w.globals.seriesTotals.reduce(
                  (a: number, b: number) => a + b,
                  0
                ),
              color: "#091420",
              fontSize: "13px",
              fontWeight: 500,
              offsetY: 20,
            },
          },
        },
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: { width: 240 },
          legend: { position: "bottom", fontSize: "11px" },
        },
      },
    ],
    stroke: { show: false },
  };

  const menu = (
    <Menu
      items={[
        { key: "1", label: "Option A" },
        { key: "2", label: "Option B" },
      ]}
    />
  );

  return (
    <div className="call-type-card">
      <div className="head">
        <div className="head-wrapper">
          <div className="flex flex-col gap-1.5">
            <div className="head-title">Call type</div>
            <p className="head-des">Overview of the call type</p>
          </div>
          {/* <div className="extra">
            <Space>
              <Dropdown overlay={menu} trigger={["click"]}>
                <EllipsisOutlined style={{ fontSize: "20px" }} />
              </Dropdown>
            </Space>
          </div> */}
        </div>
      </div>
      <div className="body">
        <ReactApexChart
          options={chartOptions}
          series={chartSeries}
          type="donut"
          width={300}
          height={300}
        />
      </div>
    </div>
  );
};

export default CallTypeDoughnutCard;
